<template>
    <section class="form-header">

        <div class="solicitation-info">
            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.general.protocol.label }}</span>
                    <span v-if="payload.general.protocol.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.general.protocol.value" disabled />
            </div>

            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.general.attProtocol.label }}</span>
                    <span v-if="payload.general.attProtocol.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" maxlength="12" v-model="payload.general.attProtocol.value" />
            </div>

            <div v-if="formType === 'solicitacoes'" class="custom-input-group flex-2">
                <div class="custom-label-group">
                    <span>Motivo de acionamento</span>
                    <span class="required-field-indicator"
                        title="Campo obrigatório">*
                    </span>
                </div>
                <multiselect v-model="subtypeSelected" :options="orderedSubtypes" :searchable="false"
                    :clear-on-select="true" :close-on-select="true" :allow-empty="false" :internal-search="false"
                    placeholder="⬇️ Tipo de solicitação..." 
                    select-label="" deselect-label="" selected-label=""
                    track-by="type" label="label" :multiple="false">
                    <span slot="noResult">
                        Nenhum resultado encontrado
                    </span>
                    <span slot="noOptions">
                        Nenhum item disponível
                    </span>
                </multiselect>
            </div>

            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>Canal</span>
                    <span class="required-field-indicator"
                        title="Campo obrigatório">*
                    </span>
                </div>
                <multiselect v-model="payload.general.channel.value" :options="channelsList" :searchable="false"
                    :clear-on-select="true" :close-on-select="true" :allow-empty="false" :internal-search="false"
                    placeholder="⬇️ Canal de atendimento..." 
                    select-label="" deselect-label="" selected-label="" :multiple="false"
                >
                    <span slot="noResult">
                        Nenhum resultado encontrado
                    </span>
                    <span slot="noOptions">
                        Nenhum item disponível
                    </span>
                </multiselect>
            </div>

            <div v-if="subtype !== 'ocorrenciaTransito'" class="checkbox-group"
                @click="payload.general.isClient = !payload.general.isClient">
                <input type="checkbox" class="form-control" v-model="payload.general.isClient" />
                <span>Cliente Tecban</span>
            </div>
        </div>

        <div class="client-info">
            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.general.solicitant.label }}</span>
                    <span v-if="payload.general.solicitant.required" class="required-field-indicator"
                    title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.general.solicitant.value"
                placeholder="Nome do solicitante" />
            </div>

            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.general.phone.label }}</span>
                    <span class="text-small">(somente números)</span>
                    <span v-if="payload.general.phone.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.general.phone.value" v-mask="phoneMask"
                    placeholder="Telefone com DDD" />
            </div>

            <div class="custom-input-group flex-1">
                <div>
                    <span>{{ payload.general.email.label }}</span>
                    <span v-if="payload.general.email.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.general.email.value"
                    placeholder="E-mail do solicitante" />
            </div>

            <div class="custom-input-group flex-1">
                <div v-if="subtype !== 'ocorrenciaTransito'" class="custom-label-group">
                    <span>{{ payload.general.address.label }}</span>
                </div>
                <div v-else>
                    <span>{{ payload.general.address.altLabel }}</span>
                    <span v-if="payload.general.address.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.general.address.value"
                    :placeholder="subtype === 'ocorrenciaTransito' ? 'Endereço da ocorrência' : 'Endereço do solicitante'" />
            </div>

        </div>

        <div v-if="payload.general.isClient" class="client-info">
            <div class="type-select">
                <div class="type-select-group" @click="payload.client.type = 'bank'"
                    :class="{ 'active-type': payload.client.type === 'bank' }">
                    <input class="form-control" type="radio" name="client-type" v-model="payload.client.type"
                        value="bank">
                    <span>Banco</span>
                </div>
                <div class="type-select-group" @click="payload.client.type = 'regular'"
                    :class="{ 'active-type': payload.client.type === 'regular' }">
                    <input class="form-control" type="radio" name="client-type" v-model="payload.client.type"
                        value="regular">
                    <span>Estabelecimento</span>
                </div>
            </div>

            <div v-if="payload.client.type === 'bank'" class="custom-input-group flex-2">
                <div class="custom-label-group">
                    <span>{{ payload.client.bank.label }}</span>
                    <span v-if="payload.client.bank.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <multiselect v-model="payload.client.bank.value" :options="filteredBanks" :searchable="true"
                    :clear-on-select="true" :internal-search="false" :custom-label="bankLabel"
                    placeholder="⬇️ Selecione o banco..." label="banco" track-by="codigo" @search-change="searchOptions"
                    :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                    :selected-label="'Selecionado'">
                    <span slot="noResult">
                        Nenhum resultado encontrado
                    </span>
                    <span slot="noOptions">
                        Nenhum item disponível
                    </span>
                </multiselect>
            </div>

            <div v-if="payload.client.type === 'bank'" class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.client.ag.label }}</span>
                    <span v-if="payload.client.ag.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <div class="input-with-button">
                    <input type="text" class="form-control" v-model="payload.client.ag.value" v-mask="'####'"
                        placeholder="4 dígitos" />
                    <button v-if="!loading" class="form-control btn-primary" @click="checkAg"><i
                            class="fas fa-search"></i> Buscar agência</button>
                    <button v-else class="form-control btn-primary" disabled><i class="fas fa-spinner fa-pulse"></i>
                        Buscando...</button>
                </div>
            </div>

            <div v-else class="custom-input-group w-50">
                <div class="custom-label-group">
                    <span>{{ payload.client.cnpj.label }}</span>
                    <span v-if="payload.client.cnpj.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <div class="input-with-button">
                    <input type="text" class="form-control" v-model="payload.client.cnpj.value"
                        v-mask="'##.###.###/####-##'" placeholder="CNPJ (somente números)" />
                    <button v-if="!loading" class="form-control btn-primary" @click="checkCNPJ"><i
                            class="fas fa-search"></i> Buscar estabelecimento</button>
                    <button v-else class="form-control btn-primary" disabled><i class="fas fa-spinner fa-pulse"></i>
                        Buscando...</button>
                </div>
            </div>
        </div>

        <div v-if="payload.general.isClient" class="client-info">
            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.client.name.label }}</span>
                    <span v-if="payload.client.name.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.client.name.value"
                    placeholder="Nome do cliente" />
            </div>

            <div class="custom-input-group flex-2">
                <div class="custom-label-group">
                    <span>{{ payload.client.fantasyName.label }}</span>
                    <span v-if="payload.client.fantasyName.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.client.fantasyName.value"
                    placeholder="Nome do ponto" />
            </div>

            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.client.cod.label }}</span>
                    <span v-if="payload.client.cod.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.client.cod.value"
                    placeholder="Código único do ponto" />
            </div>

            <div class="custom-input-group flex-1">
                <div class="custom-label-group">
                    <span>{{ payload.client.base.label }}</span>
                    <span v-if="payload.client.base.required" class="required-field-indicator"
                        title="Campo obrigatório">*</span>
                </div>
                <input type="text" class="form-control" v-model="payload.client.base.value"
                    placeholder="Nome da base" />
            </div>
        </div>

        <chooseClientModal :clients="clientsList" @client-selected="chooseClient($event)"
            :showModal="showChooseClientModal" @close-choose-modal="closeModal" />
    </section>
</template>

<script>
import { mask } from 'vue-the-mask';
import chooseClientModal from './ChooseClientModal.vue';

export default {
    directives: {
        mask
    },
    props: ['banks', 'reloadForm', 'formType', 'subtypesList'],
    components: {
        chooseClientModal
    },
    data() {
        return {
            loading: false,
            filteredBanks: [],
            clientsList: [],
            showChooseClientModal: false,
            subtypeSelected: {},
            channelsList: ['Whatsapp', 'Fone', 'E-mail'],
            payload: {
                general: {
                    protocol: { label: 'Chamado', value: '', required: true },
                    attProtocol: { label: 'Protocolo', value: '', required: false },
                    phone: { label: 'Telefone', value: '', required: true },
                    solicitant: { label: 'Solicitante', value: '', required: true },
                    address: { label: 'Endereço', altLabel: 'Local/Ponto de referência', value: '', required: false },
                    email: { label: 'E-mail', value: '', required: true },
                    isClient: false,
                    channel: { label: 'Canal', value: 'Whatsapp', required: true }
                },
                client: {
                    type: 'bank',
                    bank: { label: 'Instituição bancária', value: '', required: true },
                    ag: { label: 'Agência', value: '', required: true },
                    cnpj: { label: 'CNPJ', value: '', required: false },
                    name: { label: 'Cliente', value: '', required: true },
                    fantasyName: { label: 'Nome do ponto', value: '', required: true },
                    cod: { label: 'Código único do ponto', value: '', required: true },
                    base: { label: 'Base', value: '', required: true }
                }
            },
        }
    },
    computed: {
        phoneMask() {
            return this.payload.general.phone.value.replace(/\D/g, '').length > 10
                ? '(##) #####-####'
                : '(##) ####-####';
        },
        subtype() {
            return this.subtypeSelected ? this.subtypeSelected.type : null;
        },
        orderedSubtypes(){
            let array;
            if(this.subtypesList.length){
                array = this.subtypesList.sort((a, b) => a.label.localeCompare(b.label))
                this.subtypeSelected = array[0]
            }
            return array;
        }
    },
    created() { },
    mounted() {
        this.generateProtocol()
        this.filteredBanks = [...this.banks]
        if (this.subtype === 'ocorrenciaTransito') this.payload.general.address.required = true
    },
    methods: {
        async generateProtocol() {
            this.payload.general.protocol.value = moment().format('YYMMDDHHmmss');
        },
        searchOptions(query) {
            const keyword = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
            if (!keyword) {
                this.filteredBanks = [...this.banks]
                return;
            }

            this.filteredBanks = this.banks.filter((item) =>
                item.banco.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(keyword) ||
                item.codigo.includes(query)
            );
        },
        bankLabel(label) {
            return `${label.banco} [${label.codigo}]`
        },
        async checkCNPJ() {
            if (!this.payload.client.cnpj.value) {
                Swal.fire({
                    title: 'Digite o CNPJ',
                    html: 'Para buscar informações do estabelecimento, digite o CNPJ',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
                return
            }
            try {
                this.loading = true;
                axios.get(`${process.env.MIX_APP_URL}:4010/api/checkCNPJ`, { params: { cnpj: this.payload.client.cnpj.value } }).then(({ data }) => {
                    if (data.length) {
                        if (data.length === 1) {
                            if (data[0].NomeCliente) this.payload.client.name.value = data[0].NomeCliente
                            if (data[0].NomePonto) this.payload.client.fantasyName.value = data[0].NomePonto
                            if (data[0].EnderecoPonto) this.payload.general.address.value = data[0].EnderecoPonto
                            if (data[0].CodigoPonto) this.payload.client.cod.value = data[0].CodigoPonto
                            if (data[0].Base) this.payload.client.base.value = data[0].Base
                        } else {
                            this.clientsList = []
                            data.map(el => this.clientsList.push(el))
                            this.showChooseClientModal = true
                        }
                    } else {
                        Swal.fire({
                            title: 'Estabelecimento não encontrado',
                            html: 'Não encontramos estabelecimentos com o CNPJ informado.',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: "warning",
                            showCloseButton: true
                        })
                    }
                }).finally(() => {
                    this.loading = false
                })
            } catch (error) {
                this.loading = false
                console.error('Erro ao buscar cnpj: ', error)
                Swal.fire({
                    title: 'Erro ao buscar estabelecimento',
                    html: 'Ocorreu um erro ao buscar o estabelecimento. Por favor, entre em contato com o admnistrador.',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
            }
        },
        async checkAg() {
            if (!this.payload.client.ag.value || !Object.keys(this.payload.client.bank.value).length || !this.payload.client.bank.value) {
                Swal.fire({
                    title: 'Defina o banco e a agência',
                    html: 'Para buscar informações de agência, escolha um banco e digite a agência.',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
                return
            }
            try {
                this.loading = true;
                axios.get(`${process.env.MIX_APP_URL}:4010/api/checkAg`, { params: { ag: this.payload.client.ag.value, bankCod: this.payload.client.bank.value.codigo } }).then(({ data }) => {
                    if (data.length) {
                        if (data.length === 1) {
                            if (data[0].NomeCliente) this.payload.client.name.value = data[0].NomeCliente
                            if (data[0].NomePonto) this.payload.client.fantasyName.value = data[0].NomePonto
                            if (data[0].EnderecoPonto) this.payload.general.address.value = data[0].EnderecoPonto
                            if (data[0].CodigoPonto) this.payload.client.cod.value = data[0].CodigoPonto
                            if (data[0].Base) this.payload.client.base.value = data[0].Base
                        } else {
                            this.clientsList = []
                            data.map(el => this.clientsList.push(el))
                            this.showChooseClientModal = true
                        }
                    } else {
                        Swal.fire({
                            title: 'Agência não encontrada',
                            html: 'Não encontramos agência com o código informado.',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            type: "warning",
                            showCloseButton: true
                        })
                    }
                }).finally(() => {
                    this.loading = false
                })
            } catch (error) {
                this.loading = false
                console.error('Erro ao buscar agência: ', error)
                Swal.fire({
                    title: 'Erro ao buscar agência',
                    html: 'Ocorreu um erro ao buscar a agência. Por favor, entre em contato com o admnistrador.',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    type: "warning",
                    showCloseButton: true
                })
            }
        },
        async resetForm() {
            this.payload = {
                general: {
                    protocol: { label: 'Chamado', value: '', required: true },
                    attProtocol: { label: 'Protocolo', value: '', required: false },
                    phone: { label: 'Telefone', value: '', required: true },
                    solicitant: { label: 'Solicitante', value: '', required: true },
                    address: { label: 'Endereço', altLabel: 'Local/Ponto de referência', value: '', required: false },
                    email: { label: 'E-mail', value: '', required: true },
                    channel: { label: 'Canal', value: 'Whatsapp', required: true },
                    isClient: false,
                },
                client: {
                    type: 'bank',
                    bank: { label: 'Instituição bancária', value: '', required: true },
                    ag: { label: 'Agência', value: '', required: true },
                    cnpj: { label: 'CNPJ', value: '', required: false },
                    name: { label: 'Cliente', value: '', required: true },
                    fantasyName: { label: 'Nome do ponto', value: '', required: true },
                    cod: { label: 'Código único do ponto', value: '', required: true },
                    base: { label: 'Base', value: '', required: true }
                }
            }
            
            if(this.subtypesList.length) this.subtypeSelected = this.subtypesList[0]

            if (this.subtype === 'ocorrenciaTransito') this.payload.general.address.required = true
            this.showChooseClientModal = false;
            this.clientsList = [];
        },
        async chooseClient(data) {
            if (data.NomeCliente) this.payload.client.name.value = data.NomeCliente
            if (data.NomePonto) this.payload.client.fantasyName.value = data.NomePonto
            if (data.EnderecoPonto) this.payload.general.address.value = data.EnderecoPonto
            if (data.CodigoPonto) this.payload.client.cod.value = data.CodigoPonto
            if (data.Base) this.payload.client.base.value = data.Base
            this.clientsList = []
            this.showChooseClientModal = false
        },
        closeModal() {
            this.clientsList = []
            this.showChooseClientModal = false
        }
    },
    watch: {
        payload: {
            handler: _.debounce(function (value) {
                this.$emit('update-info', value);
            }, 1000),
            deep: true
        },
        'payload.client.type': {
            handler(value) {
                if (value === 'bank') {
                    this.payload.client.bank.required = true;
                    this.payload.client.ag.required = true;
                    this.payload.client.cnpj.required = false;
                } else if (value === 'regular') {
                    this.payload.client.bank.required = false;
                    this.payload.client.ag.required = false;
                    this.payload.client.cnpj.required = true;
                }
                // Limpar os campos preenchidos automaticamente pela integração ao mudar o tipo de cliente
                this.payload.client.bank.value = '';
                this.payload.client.ag.value = '';
                this.payload.client.cnpj.value = '';
                this.payload.client.name.value = '';
                this.payload.client.fantasyName.value = '';
                this.payload.general.address.value = '';
                this.payload.client.cod.value = '';
                this.payload.client.base.value = '';
                this.clientsList = []
            }
        },
        async reloadForm(value) {
            await this.resetForm()
            await this.generateProtocol()
        },
        'payload.client.bank.value': {
            handler(value) {
                this.payload.client.ag.value = '';
                this.payload.client.cnpj.value = '';
                this.payload.client.name.value = '';
                this.payload.client.fantasyName.value = '';
                this.payload.general.address.value = '';
                this.payload.client.cod.value = '';
                this.payload.client.base.value = '';
            }
        },
        subtypeSelected: {
            handler(value) {
                this.$emit('change-subtype', value)
            },
            deep: true
        },
        'payload.general.channel.value': {
            handler(value) {
                if(value === 'E-mail') {
                    this.payload.general.phone.required = false
                } else {
                    this.payload.general.phone.required = true
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-header {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input,
    textarea {
        box-shadow: none;
    }

    .solicitation-info {
        display: flex;
        gap: 10px;
    }

    .client-info {
        display: flex;
        gap: 10px;
        min-height: 70px;
    }

    .custom-input-group {
        display: flex;
        flex-direction: column;
        text-align: start;
        width: 100%;

        span {
            font-weight: bold;
        }

        textarea {
            resize: none
        }

        .input-with-button {
            display: flex;
            gap: 5px;
            height: 100%;
            align-items: center;

            button {
                border-radius: 10px !important;
                box-shadow: none;
                width: fit-content;
                white-space: nowrap;
            }
        }

        .custom-label-group {
            display: flex;
            flex-wrap: nowrap;
            white-space: nowrap;
            align-items: center;
            gap: 3px;
        }
    }

    .checkbox-group {
        display: flex;
        gap: 5px;
        padding: 2px 10px;
        height: fit-content;
        align-self: end;
        cursor: pointer;
        border: 1px solid #ededed;
        border-radius: 10px;
        box-shadow: 1px 1px 2px 0px lightgray;
        transition: ease-in-out 0.2s;

        span {
            white-space: nowrap;
            align-content: center;
            font-weight: bold;
        }

        input {
            cursor: pointer;
        }

        &:hover {
            background-color: #ededed;
        }
    }

    .type-select {
        display: flex;
        width: fit-content;
        gap: 10px;
        flex-wrap: wrap;
        height: fit-content;
        align-self: end;

        &-group {
            display: flex;
            gap: 5px;
            padding: 2px 10px;
            cursor: pointer;
            border: 1px solid #ededed;
            border-radius: 10px;
            box-shadow: 1px 1px 2px 0px lightgray;
            transition: ease-in-out 0.2s;

            span {
                white-space: nowrap;
                align-content: center;
                font-size: medium;
                font-weight: bold;
            }

            input {
                box-shadow: none;
                cursor: pointer;
            }

            &:hover {
                background-color: #ededed;
            }
        }
    }

    .buttons-container {
        display: flex;
        justify-content: flex-end;
        gap: 5px;
        margin: 10px;

        button {
            width: 100px;
            color: white;
            border-radius: 10px !important;
            box-shadow: none;
            transition: ease-in-out 0.2s
        }

        #save-button {
            background-color: darkgreen;

            &:hover {
                background-color: #023b02;
            }
        }

        #cancel-button {
            background-color: #a00404;

            &:hover {
                background-color: #6d0303;
            }
        }
    }
}

.text-small {
    font-size: x-small
}

.required-field-indicator {
    font-size: small;
    text-align: start;
    color: red;
}

.flex-1 {
    flex: 1
}

.flex-2 {
    flex: 2
}

.flex-3 {
    flex: 3
}

.active-type {
    background-color: #ededed;
}
</style>